module.exports = __webpack_public_path__ + "static/media/img3@2x.cb61168e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img3@2x.jpg
// module id = 1782
// module chunks = 0 1